import Api from "../../../../services/Api";

function fetchLatestLogs(serialNumber, startDate, endDate) {
  return Api.post(
    `/service/evse_management/api/v1/evse/${serialNumber}/upload_ocpp_logs?start_date=${startDate}&end_date=${endDate}`
  );
}

export { fetchLatestLogs };
